module.exports = __webpack_public_path__ + "static/media/calabash_container.4567239d.jpg";